const btnReducer = (state = "", action) => {
    switch (action.type) {
        case "setActiveBtn":
            return action.payload;
        default:
            return state;
    }
};

export default btnReducer;
